'use client';

import React, { useState } from 'react';

const MobileRecursiveMenuItem = ({ item, handleMenuClick, depth = 0 }) => {
  const hasChildren = item.children && item.children.length > 0;
  const [isExpanded, setIsExpanded] = useState(false);

  const onParentClick = (e) => {
    if (hasChildren) {
      e.preventDefault();
      setIsExpanded(!isExpanded);
    } else {
      handleMenuClick(item.path)(e);
    }
  };

  return (
    <li className={`depth-${depth} list-none px-0`}>
      <div
        className="mobile-item-wrapper flex cursor-pointer items-center justify-between px-0"
        onClick={onParentClick}
      >
        <span className="header-menu-item text-[0.875rem] leading-[1.43] text-white px-0">{item.label}</span>
        {hasChildren && <span className={`chevron ${isExpanded ? 'up' : 'down'} px-0`}></span>}
      </div>

      {hasChildren && isExpanded && (
        <ul className="children m-0 list-none p-0 px-0">
          <li className={`depth-${depth + 1} overview-link list-none px-0`}>
            <div
              className="mobile-item-wrapper flex cursor-pointer items-center justify-between px-0"
              onClick={handleMenuClick(item.path)}
            >
              <span className="header-menu-item text-[0.875rem] font-bold leading-[1.43] text-white px-0">
                Zobacz wszystko w {item.label}
              </span>
            </div>
          </li>

          {item.children.map((child) => (
            <MobileRecursiveMenuItem key={child.id} item={child} handleMenuClick={handleMenuClick} depth={depth + 1} />
          ))}
        </ul>
      )}
    </li>
  );
};

export default MobileRecursiveMenuItem;
